import Box from '@components/base/Box'
import { Button } from '@components/inputs/Button'
import React from 'react'
import { useState } from 'react'
import { MdDragHandle } from 'react-icons/md'
import { ReactElement } from 'react-markdown/lib/react-markdown'

type ResizeableValue = number | 'full'

interface ResizeableProps {
  children: JSX.Element
  enabled?: boolean
  initalSize?: {
    width?: ResizeableValue
    height?: ResizeableValue
  }
  className?: string
  // targetRef: RefObject<T>
}

interface ElementSize {
  width: ResizeableValue
  height: ResizeableValue
}

// interface ResizeablePayload {
//   handler: JSX.Element
//   element: JSX.Element
// }

const Resizeable = ({
  children,
  enabled = true,
  initalSize,
  className = '',
}: ResizeableProps) => {
  const getInitialSize = () => {
    return { width: 0, height: 0, ...initalSize }
  }

  const [size, setSize] = useState<ElementSize>(getInitialSize())

  const onMouseDown = (e: React.MouseEvent) => {
    const startSize = size
    const startPosition = { x: e.pageX, y: e.pageY }
    const onMouseMove = (evt: MouseEvent) => {
      setSize((state) => ({
        ...state,
        height:
          startSize.height === 'full'
            ? 0
            : startSize.height - startPosition.y + evt.pageY,
      }))
    }

    const onMouseUp = () => {
      document.body.removeEventListener('mousemove', onMouseMove)
      document.body.removeEventListener('mouseup', onMouseUp)
    }

    document.body.addEventListener('mousemove', onMouseMove)
    document.body.addEventListener('mouseup', onMouseUp)
  }

  const resizeHandle = (
    <span className={`absolute bottom-0 w-full`} onMouseDown={onMouseDown}>
      <MdDragHandle style={{ cursor: 'row-resize' }} className="mx-auto" />
    </span>
  )

  if (!enabled) return <Box className={`relative ${className}`}>{children}</Box>

  const payload = (
    <Box
      className={`relative ${className}`}
      style={{ height: size.height === 'full' ? '100%' : `${size.height}px` }}
    >
      {children}
      {resizeHandle}
    </Box>
  )
  return payload
}

export default Resizeable
